import React, { useState, useCallback, useEffect } from "react";
import { Form, Dropdown, Input, Button, Checkbox } from "semantic-ui-react";
import { Label, StyledButton, ContainerLimitante,Select } from "./styles";
import { pb4y as api, producaov2 } from "../../../../../../services/apis";
import { isAuthAdmin } from "../../../../../../services/auth";
import * as yup from "yup";

import swal from "sweetalert";

import { Link } from "react-router-dom";
import { generateCupomCode, returnValidate } from "../../../../../../utils/Utils";

const Formulario = (props) => {
  const [cupom, setCupom] = useState({
    cupom: [],
    ativo: 1,
    usado: 0,
    max_uso: 6000,
    tempo_validade: "+12 months",
    isParceiro: 0,
    multipleCodes: false,
  });
  const [startNumber, setStartNumber] = useState(1);
  const [codigoAlfab, setCodigoAlfab] = useState();
  const [numCodigo, setNumCodigo] = useState(1);
  const [randomicHash, setRandomicHash] = useState(false);
  const [ativo,setAtivo] = useState(true);
  const [status, setStatus] = useState(5);

  useEffect(() => {
    loadAuth();
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }

  };

  const create = async () => {
    const cupomValidation = await yup.object().shape({
      cupom: yup
        .string("Necessário que informe o nome do cupom")
        .required("Necessário que informe o nome do cupom"),
    });
    try {
      await cupomValidation.validate(cupom, { abortEarly: true });
      if (cupom.multipleCodes) {
        cupom.cupom.map(async (elem) => {
          const data = {
            cupom: elem.toString().toUpperCase(),
            ativo: ativo ? 1 : 0 ,
            usado: cupom.usado,
            max_uso: cupom.max_uso,
            tempo_validade: returnValidate(status),
            isParceiro: cupom.isParceiro,
          };
          api
            .post(`/admin/cupons`, data, {headers: {access_token: `voitto-token ${localStorage.getItem("oauth_token")}`}})
            .then((res) => {
              let logs = {
                local: "PocketBook",
                texto: `criou o cupom de id=${res.data.id}`,
              };
              producaov2.post("system_logs", { acao: JSON.stringify(logs) });
              props.props.history.push("/admin/pocketbook/cupons");
            })
            .catch((err) => {
              swal("Não foi possível salvar o cupom", err, "");
            });
        });
      } else {
        const data = {
          cupom: cupom.cupom.toString().toUpperCase(),
          ativo: ativo ? 1 : 0,
          usado: cupom.usado,
          max_uso: cupom.max_uso,
          tempo_validade: returnValidate(status),
          isParceiro: cupom.isParceiro,
        };
        api
          .post(`/admin/cupons`, data, {headers: {access_token: `voitto-token ${localStorage.getItem("oauth_token")}`}})
          .then((res) => {
            let logs = {
              local: "PocketBook",
              texto: `criou o cupom de id=${res.data.id}`,
            };
            producaov2.post("system_logs", { acao: JSON.stringify(logs) });
            props.props.history.push("/admin/pocketbook/cupons");
          })
          .catch((err) => {
            swal("Não foi possível salvar o cupom", err, "");
          });
      }
    } catch (err) {
      if (err instanceof yup.ValidationError) {
        swal("Erro!", `${err}`, "error");
        return;
      }
    }
  };

  const handleCupom = useCallback(
    (e) => {
      setCupom({ ...cupom, cupom: e });
    },
    [cupom]
  );

  async function gerarCodigos() {
    let arrayCodigos = [];
    if(randomicHash) {
      for (let i = 1; i <= numCodigo; i++) {
        const now = await generateCupomCode(codigoAlfab)
        arrayCodigos.push(now);
      }
      return handleCupom(arrayCodigos);
    }
    for (let i = 0; i < numCodigo; i++) {
      const soma = i + parseInt(startNumber);
      arrayCodigos.push(`${codigoAlfab}${soma}`);
    }
    return handleCupom(arrayCodigos);
  }

  const statusOptions = [
    "Validade 1 mês",
    "Validade 2 meses",
    "Validade 3 meses",
    "Validade 4 meses",
    "Validade 5 meses",
    "Validade 6 meses",
    "Validade 7 meses",
    "Validade 8 meses",
    "Validade 9 meses",
    "Validade 10 meses",
    "Validade 11 meses",
    "Validade 12 meses",
  ];


  return (
    <Form>
      <Form.Group widths="equal">
        <Form.Field>
          <Checkbox
            label="Gerar múltiplos codigos?"
            onChange={() => setCupom({ multipleCodes: !cupom.multipleCodes })}
            checked={cupom.multipleCodes}
          />
          {cupom.multipleCodes && (
            <ContainerLimitante>
              <Label>Parte alfabética</Label>
              <Form.Input
                placeholder="ABCDEF"
                value={codigoAlfab}
                required
                onChange={(e) => setCodigoAlfab(e.target.value)}
              />
              <br></br>
              <Checkbox
                label="Gerar códigos aleatórios?"
                onChange={() => setRandomicHash(!randomicHash)}
                checked={randomicHash}
                />
                <br></br>
                <br></br>
              {
                !randomicHash && (
                  <>
                    <Label>Gerar a partir do número</Label>
                    <Form.Input
                      type="number"
                      min="1"
                      value={startNumber}
                      onChange={(e) => setStartNumber(e.target.value)}
                      />
                  </>
                )
              }
              <Label>Número de códigos a serem gerados</Label>
              <Form.Input
                type="number"
                min="1"
                value={numCodigo}
                onChange={(e) => setNumCodigo(e.target.value)}
              />
              <br></br>
              <StyledButton onClick={codigoAlfab && gerarCodigos}>Gerar códigos</StyledButton>
            </ContainerLimitante>
          )}
        </Form.Field>
      </Form.Group>
      <Form.Group widths="equal">
        <Form.Field
          control={Input}
          label="Cupom"
          placeholder="Cupom"
          value={cupom.cupom}
          onChange={(e) => {
            setCupom({ ...cupom, cupom: e.target.value });
          }}
        />
      </Form.Group>

      <Form.Group widths="equal">
      <Form.Field>
        <Checkbox
          label="Ativo"
          onChange={() => setAtivo(!ativo)}
          checked={ativo}
          />
          </Form.Field>
        {/* <Form.Field
          control={Input}
          label="Ativo"
          placeholder="Ativo"
          type="number"
          value={cupom.ativo}
          onChange={(e) => {
            e.target.value > 0
              ? setCupom({ ...cupom, ativo: 1 })
              : setCupom({ ...cupom, ativo: 0 });
          }}
        /> */}
      </Form.Group>

      <Form.Group widths="equal">
        <Form.Field
          control={Input}
          label="Usado"
          placeholder="Usado"
          type="number"
          value={cupom.usado}
          onChange={(e) => {
            e.target.value > 0
              ? setCupom({ ...cupom, usado: 1 })
              : setCupom({ ...cupom, usado: 0 });
          }}
        />
      </Form.Group>

      <Form.Group widths="equal">
        <Form.Field
          control={Input}
          label="Uso máximo"
          placeholder="Uso máximo"
          type="number"
          value={cupom.max_uso}
          onChange={(e) => {
            setCupom({ ...cupom, max_uso: e.target.value });
          }}
        />
      </Form.Group>

      <Label>Validade</Label>
      <Form.Group widths="equal">
        <Select
          title={statusOptions[status]}
          value={status}
          onChange={(e) => setStatus(e.target.value)}
        >
          {statusOptions.map((text, index) => (
            <option value={index}>{text}</option>
          ))}
        </Select>
      </Form.Group>
      <Form.Group widths="equal">
        <Form.Field
          control={Input}
          label="Parceiro"
          placeholder="Parceiro"
          type="number"
          value={cupom.isParceiro}
          onChange={(e) => {
            e.target.value > 0
              ? setCupom({ ...cupom, isParceiro: 1 })
              : setCupom({ ...cupom, isParceiro: 0 });
          }}
        />
      </Form.Group>

      <Form.Group>
        <Form.Field control={Button} onClick={() => create()}>
          Criar
        </Form.Field>
        <Link to="/admin/pocketbook/cupons">
          <Button color="secondary">Cancelar</Button>
        </Link>
      </Form.Group>
    </Form>
  );
};

export default Formulario;
